export enum UserIntegrationType {
  HUBSPOT = 'hubspot',
  PASSCREATOR = 'passcreator',
}
